import { useSelector } from "react-redux";
import { LoadedDestinationInfo } from "../types/global";
import { DestinationState } from "../reducers/destinations";

export default function useFirstDestinationOfType(
  destinationType: string
): LoadedDestinationInfo | undefined {
  return useSelector((state: { destinations: DestinationState }) =>
    Object.values(state.destinations.data).find(
      (destination) => destination.type_slug === destinationType
    )
  );
}
